import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute bottom-0 right-0 block h-2 w-2 rounded-full bg-sa-red-500 ring-2 ring-white"
}

import {onMounted, Ref, ref} from "vue";
import {store} from "@/store";
export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationIndicator',
  setup(__props) {

// @ts-ignore

return (_ctx: any,_cache: any) => {
  return (_unref(store).displayNotification)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1))
    : _createCommentVNode("", true)
}
}

})